<template>
  <div>
    <v-col v-if="status == 'COMPLETE'" class="pa-0 ma-0">
      <v-row class="mb-1">
        <v-col
          ><h6 class="caption font-weight-light">
            {{ this.status }}
          </h6></v-col
        >
        <v-col cols="auto">
          <v-menu open-on-hover bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-2"
                color="blue-grey"
                v-bind="attrs"
                v-on="on"
                x-small
                dark
                depressed
              >
                Change
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in addItems"
                :key="index"
                link
                @change="showAddContentDialog(item.action)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            color="blue-grey"
            x-small
            dark
            depressed
            @click="download()"
            v-if="this.stream_mode == 'video'"
          >
            Download
          </v-btn>
        </v-col>
      </v-row>

      <div>
        <video-player
          :options="videoOptions"
          :poster="poster"
          :stream_mode="stream_mode"
          :stream_url="stream_url"
          :stream_timelimit="stream_timelimit"
          :content_id="id"
          :autoplay="autoplay"
          :key="videoKey"
        />
      </div>

      <v-col cols="12" class="pa-0 pt-6 ma-0">
        <h6
          class="subtitle-1 blue-grey--text text--darken-2 font-weight-regular"
        >
          Poster
        </h6>
        <v-row>
          <v-col>
            <Posters
              :id="content.id"
              :poster="poster"
              :poster_upload="poster_upload"
              :key="posterKey"
              @changePoster="onChangePoster"
            ></Posters>
          </v-col>
        </v-row>
      </v-col>
    </v-col>
    <v-col v-if="status != 'COMPLETE'">
      <div class="text-center">
        <v-card color="#212121" dark>
          <v-responsive :aspect-ratio="16 / 9">
            <v-card-text
              class="d-flex align-center justify-center"
              style="height: 100%"
            >
              <v-row>
                <v-col cols="12">
                  It will take several minutes to optimize this video.
                </v-col>
                <v-col cols="12">
                  <v-icon
                    small
                    v-if="
                      this.status.includes('UPLOADING') ||
                        this.status.includes('PENDING') ||
                        this.status.includes('PROGRESSING') ||
                        this.status.includes('OPTIMIZING')
                    "
                    >mdi-autorenew mdi-spin</v-icon
                  >
                  {{ showStatus(this.status) }}
                </v-col>
                <v-col cols="12">
                  Content information can be modified during optimization.
                </v-col>
              </v-row>
            </v-card-text>
          </v-responsive>
        </v-card>
      </div>
    </v-col>
    <!-- 컨텐츠 생성(업로드) 모달창 -->
    <v-dialog v-model="uploadDialog" width="600px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Upload Video</v-card-title>
          <div class="ml-auto">
            <v-btn icon color="error" @click="closeUploadDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <v-form ref="form2">
            <dropUploader
              v-on:uploadfile="dropUploadFile"
              text="Drag and drop Video File (mp4, mov, wmv, avi, ts) or"
              type="video/mp4,video/x-ms-wmv,video/x-ms-asf,video/x-msvideo,,video/avi,video/quicktime,video/mov,video/MP2T"
              length="50"
              size="5120"
              multiple="false"
              width="400"
              :uploading="dropUploading"
            ></dropUploader>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- embed 모달 창 -->
    <v-dialog v-model="embedDialog" width="600px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Embed Video</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="closeEmbedDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-10 pb-0">
          <v-form ref="form3">
            <v-text-field
              v-model="stream_url_input"
              outlined
              name="input-7-4"
              label="Enter Youtube or Vimeo Url"
              :rules="[embedUrlRules]"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="channelbtn"
            class="mr-2 white--text"
            @click="embedVideo"
            depressed
          >
            Save
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="closeEmbedDialog()"
            depressed
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import VideoPlayer from "@/components/VideoPlayer.vue";
import { onUpdateContent } from "../graphql/Subscription";
import { createFile, updateContent } from "../graphql/Mutation";
import { mapState } from "vuex";
const dropUploader = () => import("@/components/DragAndDropUploader");
const Posters = () => import("@/components/Posters");
const APP_BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
  name: "ContentVideo",
  props: ["content"],
  components: {
    VideoPlayer,
    Posters,
    dropUploader
  },
  data: () => ({
    mountTime: true,
    id: "",
    uploadDialog: false,
    embedDialog: false,
    uploadSlideSuccess: false,
    dropUploading: false,
    uploadingProcess: [],
    player: null,
    status: "",
    previousStatus: "",
    autoplay: false,
    stream_mode: "",
    stream_url: "",
    stream_url_input: "",
    stream_timelimit: "",
    width: "",
    addItems: [
      { title: "Upload Video", action: "upload" },
      { title: "Embed Video", action: "embed" }
    ],
    mp4File: {},
    poster_upload: "",
    poster: "",
    uploading: false,
    value: 0,
    videoOptions: {
      controls: true,
      preload: "no",
      sources: [
        {
          src: "",
          type: "application/x-mpegURL",
          withCredentials: false
        }
      ]
    },
    videoKey: 1,
    posterKey: 1
  }),

  async mounted() {
    console.log("[ContentVideo]", this.content);
    await this.init();
  },
  computed: {
    ...mapState(["uploadingContent"]),
    progressVal: function() {
      let rtnVal;
      if (
        this.status.includes("UPLOADING") ||
        this.status.includes("OPTIMIZING")
      ) {
        if (this.status == "OPTIMIZING" || this.status == "UPLOADING") {
          rtnVal = 0;
        } else {
          const temp = this.status.split(" ");
          const percent = temp[1];
          const percentText = percent.slice(0, -1);
          const num = parseInt(percentText);
          console.log(temp, percent, percentText, num);
          rtnVal = num;
        }
      } else {
        rtnVal = 0;
      }
      return rtnVal;
    },
    progressColor: function() {
      let color;
      if (this.status.includes("UPLOADING")) color = "primary";
      if (this.status.includes("OPTIMIZING")) color = "teal";
      return color;
    }
  },
  watch: {
    uploadingContent: {
      handler: function(newVal) {
        if (newVal.length > 0) {
          const idx = newVal.findIndex(item => item.file_id == this.id);
          console.log({ idx });
          if (idx > -1) {
            const status = newVal[idx].status;
            if (status.includes("UPLOADING")) this.status = status;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    async init() {
      console.log("[ContentVideo] 초기화");
      this.id = this.content.id;
      this.status = this.content.status;
      if (this.status == "COMPLETE") this.previousStatus = "COMPLETE";
      this.stream_mode = this.content.stream_mode;
      this.stream_url = this.content.stream_url;
      this.stream_timelimit = this.content.stream_timelimit;
      this.poster = this.content.poster;
      this.poster_upload = this.content.poster_upload;
      this.autoplay = this.content.autoplay ? this.content.autoplay : false;
      this.mp4File = this.content.mp4File;

      // video설정
      this.videoOptions.sources[0].src = APP_BASE_URL + this.stream_url;
      if (this.autoplay) {
        this.videoOptions.autoplay = true;
      }

      // poster설정

      console.log(
        "[mount 끝]",
        this.id,
        this.status,
        this.stream_mode,
        this.poster,
        this.poster_upload
      );
    },

    async refreshPosterList() {
      // posterList 보여주기
      await this.makePosterList();
      // poster 선택 체크
      this.checkPoster();
    },

    showAddContentDialog(action) {
      /**
       * 업로드 비디오, 임베드 비디오 선택해서 보여주기
       */
      if (action == "upload") this.uploadDialog = true;
      if (action == "embed") this.embedDialog = true;
    },
    showStatus(status) {
      let rtnStatus = status;
      if (status.includes("UPLOADING")) rtnStatus = "UPLOADING";
      if (status.includes("PENDING")) rtnStatus = "PENDING";
      if (status.includes("OPTIMIZING")) rtnStatus = "OPTIMIZING";
      if (status.includes("COMPLETE")) rtnStatus = "COMPLETE";
      return rtnStatus;
    },
    closeEmbedDialog() {
      this.$refs.form3.reset();
      this.$refs.form3.resetValidation();
      this.embedDialog = false;
    },
    closeUploadDialog() {
      this.$refs.form2.reset();
      this.$refs.form2.resetValidation();
      this.uploadDialog = false;
    },
    embedUrlRules(v) {
      const youtubePattern = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;
      const isYoutube = youtubePattern.test(v);

      const vimeoPattern = /(?:http:|https:|)\/\/(?:player.|www.)?vimeo\.com\/(?:video\/|embed\/|watch\?\S*v=|v\/)?(\d*)/;
      const isVimeo = vimeoPattern.test(v);

      if (isYoutube || isVimeo) {
        return true;
      } else {
        return "Url should be vaild.";
      }
    },
    dropUploadFile(event) {
      const uploadFiles = event;
      const files = uploadFiles;
      const promises = files.map(file => this.uploadVideo(file));

      Promise.all(promises)
        .then(res => {
          console.log("Promise All Clear!", res);
        })
        .catch(e => {
          console.log("Promise failed", e);
        });
    },
    uploadVideo(file) {
      return new Promise((resolve, reject) => {
        // const name = file.name.slice(0, file.name.lastIndexOf("."));
        // 초기화

        const content_id = this.id;
        const channel_id = this.$store.state.channelId;
        const file_id = content_id;
        // 업로드 창 닫기
        this.closeUploadDialog();

        const input = {
          id: content_id,
          channel_id: channel_id,
          uploading_at: Date.now().toString()
        };
        // 컨텐츠 DB등록
        this.$apollo
          .mutate({
            mutation: updateContent,
            variables: { input },
            fetchPolicy: "no-cache"
          })
          .then(() => {
            return this.$apollo.mutate({
              mutation: createFile,
              variables: {
                channel_id: channel_id,
                content_id: content_id,
                mode: "video",
                name: file.name,
                fileType: file.type,
                file_id: file_id
              },
              fetchPolicy: "no-cache"
            });
          })
          .then(res => {
            const uploadUrl = res.data.createFile.url;
            const file_id = res.data.createFile.file_id;
            const params = {
              mode: "start",
              file: file,
              file_id: file_id,
              file_name: file.name,
              url: uploadUrl
            };
            this.$store.dispatch("uploadVideo", params);
            resolve(file_id);
          })
          .catch(e => {
            console.log("error", e);
            reject(file);
          });
      });
    },
    async embedVideo() {
      if (!this.$refs.form3.validate()) return;
      const channel_id = this.$store.state.channelId;
      const input = {
        id: this.id,
        channel_id,
        stream_mode: "embed",
        stream_url: this.stream_url_input,
        status: "COMPLETE"
      };
      // 컨텐츠 DB등록
      try {
        const { data } = await this.$apollo.mutate({
          mutation: updateContent,
          variables: { input },
          fetchPolicy: "no-cache"
        });

        console.log("[Changed / embed video]", { data });
        if (data && data.updateContent) {
          const res = data.updateContent;
          this.stream_url = res.stream_url;
          this.stream_mode = res.stream_mode;
          this.status = res.status;
          this.closeEmbedDialog();
          this.videoKey += 1;
          await this.timeout(2000);
          await this.refreshPosterList();
        }
        // 업로드 창 닫기
        this.closeEmbedDialog();

        // this.videoKey += 1;
        // await this.timeout(2000);
        // await this.refreshPosterList();
      } catch (e) {
        console.log(e);
      }
    },
    download() {
      console.log(this.mp4File);

      if (this.mp4File && this.mp4File.signedUrl) {
        const url = this.mp4File.signedUrl;
        var element = document.createElement("a");
        element.setAttribute("href", url);
        element.setAttribute("download", this.content.title);
        element.setAttribute("target", "_new");
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      } else {
        this.$notify({
          type: "error",
          title: "Video download is in preparation.",
          text:
            "It will take some time to prepare the video for download. Please try again in a few minutes.",
          duration: 6000,
          closeOnClick: true
        });
      }
    },

    timeout(ms) {
      //pass a time in milliseconds to this function
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async onChangePoster(obj) {
      console.log("onChangePoster", obj);
      this.poster = obj.poster;
      this.poster_upload = obj.poster_upload;
      await this.updatePoster();
    },
    async updatePoster() {
      const updateInput = {
        id: this.id,
        channel_id: this.$store.state.channelId,
        poster_upload: this.poster_upload,
        poster: this.poster
      };
      console.log("updateContent Exec", updateInput);

      try {
        const { data } = await this.$apollo.mutate({
          mutation: updateContent,
          variables: {
            input: updateInput
          },
          fetchPolicy: "no-cache"
        });

        if (data && data.updateContent) {
          const res = data.updateContent;
          if (res) {
            this.$store.dispatch("logger", {
              menu: "Contents",
              level: "success",
              message: `Success for Updating ${this.id} Content's poster. `
            });
          }
          this.videoKey += 1;
        }
      } catch (e) {
        this.$store.dispatch("logger", {
          menu: "Contents",
          level: "error",
          message: `Fail for Updating Poster of Content[${this.id}].`
        });
        console.log("[Contents] Update Content", e);
      }
    }
  },
  apollo: {
    $subscribe: {
      onUpdateContent: {
        query: onUpdateContent,
        variables() {
          return {
            channel_id: this.$store.state.channelId
          };
        },
        async result(data) {
          const item = data.data.onUpdateContent;
          const id = item.id;
          const status = item.status;
          const stream_mode = item.stream_mode;
          const stream_url = item.stream_url;
          // const stream_timelimit = item.stream_timelimit;
          const poster = item.poster;
          const poster_upload = item.poster_upload;
          const autoplay = item.autoplay ? item.autoplay : false;
          console.log("구독 updateContent", {
            id,
            status,
            poster,
            poster_upload,
            stream_mode,
            stream_url,
            // stream_timelimit,
            autoplay
          });

          if (this.id == id) {
            this.stream_mode = stream_mode;
            this.stream_url = stream_url;
            // this.stream_timelimit = stream_timelimit;

            this.autoplay = autoplay;
            if (this.previousStatus != "COMPLETE" && status == "COMPLETE") {
              this.status = status;
              // video설정
              // this.videoOptions.sources[0].src = APP_BASE_URL + this.stream_url;
              // if (this.autoplay) {
              //   this.videoOptions.autoplay = true;
              // }
              // this.videoKey += 1;

              // const url = APP_BASE_URL + 'content?content_id=' + this.id;
              // console.log({url});
              window.history.forward(1);
            } else {
              this.status = status;
            }
          }

          this.previousStatus = status;
        },
        error(error) {
          console.error(error);
        }
      }
    }
  }
};
</script>
<style>
.v-progress-circular {
  margin: 1rem;
}
.poster_btn {
  border: 1px dotted;
  height: 100% !important;
}
</style>
